import { Link } from "react-router-dom";
import { Users, CalendarRange, ShieldCheck, ArrowRight, Building2 } from "lucide-react";
import { useSeo } from "../lib/seo";
import { useAuth } from "../context/AuthContext";
import { PublicHeader, PublicFooter } from "../components/PublicShell";

const BENEFITS = [
  { Icon: Users, t: "Licenses for your whole team", d: "Invite, assign, replace and track dentist access from one dashboard." },
  { Icon: CalendarRange, t: "One contract, one renewal date", d: "Every license follows your organization's contract period — renew everyone together." },
  { Icon: ShieldCheck, t: "Clinical privacy by design", d: "Admins manage licenses & billing — never dentists' patient cases." },
];
const FLOW = ["Request", "Custom quotation", "Accept", "Pay", "Invite dentists", "Manage licenses", "Renew"];

export default function Institutions() {
  const { user } = useAuth();
  useSeo({ title: "DentiCision for Clinics & Organizations — Institutional subscriptions", path: "/institutions",
    description: "Institutional DentiCision subscriptions for dental clinics, medical centres, dental groups and universities: custom quotations, centralized dentist licenses and one renewal date." });
  return (
    <div className="min-h-screen bg-slate-50" data-testid="institutions-page">
      <PublicHeader />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-14">
        <div className="rounded-3xl bg-gradient-to-br from-[#0B2545] to-[#13315C] text-white p-8 sm:p-12 grid lg:grid-cols-5 gap-10">
          <div className="lg:col-span-3">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-sky-300 flex items-center gap-2"><Building2 className="w-4 h-4" /> For Clinics & Organizations</p>
            <h1 className="font-heading text-4xl sm:text-5xl font-bold leading-tight mt-3">Empower your dental team with evidence-based clinical decision support.</h1>
            <p className="text-sky-100/90 mt-4 max-w-xl">For dental clinics, medical centres, dental groups, universities and healthcare organizations. Receive a custom quotation for your team — managed entirely inside DentiCision.</p>
            <Link to={user ? "/app/organization" : "/register?next=/app/organization"} data-testid="institutions-cta"
              className="mt-8 inline-flex items-center gap-2 h-12 px-7 rounded-xl bg-[#1C6FE3] font-semibold hover:bg-[#1659b8] transition-colors">
              Request an institutional quotation <ArrowRight className="w-4 h-4" />
            </Link>
            {!user && <p className="text-xs text-sky-100/70 mt-3">Already have an account? <Link to="/login?next=/app/organization" className="underline">Sign in</Link> to submit your request.</p>}
          </div>
          <ul className="lg:col-span-2 space-y-6">
            {BENEFITS.map(({ Icon, t, d }) => (
              <li key={t} className="flex gap-3"><Icon className="w-5 h-5 text-sky-300 shrink-0 mt-0.5" /><div><p className="font-semibold">{t}</p><p className="text-sm text-sky-100/80">{d}</p></div></li>
            ))}
          </ul>
        </div>
        <div className="mt-10 flex flex-wrap gap-2">
          {FLOW.map((s, i) => <div key={s} className="flex-1 min-w-[120px] rounded-xl bg-white border border-slate-200 p-4"><p className="text-xs font-bold text-[#1C6FE3]">{i + 1}</p><p className="text-sm font-semibold text-[#0B2545]">{s}</p></div>)}
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
